export default function PHP_ftp_pasv() {
  return (
    <div>
      <h1>PHP_ftp_pasv</h1>
    </div>
  );
}
